import { render } from "./CertiAccInfoM.vue?vue&type=template&id=6dda3af6"
import script from "./CertiAccInfoM.vue?vue&type=script&lang=js"
export * from "./CertiAccInfoM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__